import React from 'react';
import S3Lightbox from './S3Lightbox';

const GrandTeton = () => {
    
    return ( 
        <S3Lightbox searchKey='GrandTeton'></S3Lightbox> 
     );
}
 
export default GrandTeton;